import { TActionObjectDTO } from "Types";

export class ActionObjectLogic {

    findDuplicatedActionObjectInList = (action: string, obj: string, actionObjectList: TActionObjectDTO[]): TActionObjectDTO | undefined => {
        // safety-checks
        if (!action || !obj || !actionObjectList) return undefined;

        for (const actionObject of actionObjectList) {
            if (actionObject.action.trim().toLowerCase() === action.trim().toLowerCase() &&
                actionObject.dobject.trim().toLowerCase() === obj.trim().toLowerCase()) return actionObject;
        }

        return undefined;
    };

}

export const ActionObjectLogicSingleton = new ActionObjectLogic();